import "webrtc-adapter";
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import store from "./store/store";
import Loader from "./components/ui/SuspenseLoader/SuspenseLoader";
import ErrorBoundary from "./components/ui/ErrorBoundry/ErrorBoundry";
import AjaxResponseHandler from "./components/AjaxResponseHandler/AjaxResponseHandler";
import AppRoutes from "./components/Layout/Content/AppRoutes";
import "./app.scss";

const App = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            <AjaxResponseHandler />
            <AppRoutes />
          </Suspense>
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
  );
};

export default App;
